import React from "react"

const CloseIcon = ({ fill = "#1C1B1F", h = "8", w = "9", onClick }) => {
  return (
    <svg
      width={w}
      height={h}
      onClick={onClick}
      className="cursor-pointer"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66988 3.11621L7.76363 0.0224609L8.64738 0.906211L5.55363 3.99996L8.64738 7.09371L7.76363 7.97746L4.66988 4.88371L1.57613 7.97746L0.692383 7.09371L3.78613 3.99996L0.692383 0.906211L1.57613 0.0224609L4.66988 3.11621Z"
        fill={fill}
      />
    </svg>
  )
}

export default CloseIcon
